import { render, staticRenderFns } from "./HealthyMeasureTableCard.vue?vue&type=template&id=52d74e2a&scoped=true"
import script from "./HealthyMeasureTableCard.vue?vue&type=script&lang=js"
export * from "./HealthyMeasureTableCard.vue?vue&type=script&lang=js"
import style0 from "./HealthyMeasureTableCard.vue?vue&type=style&index=0&id=52d74e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d74e2a",
  null
  
)

export default component.exports